import { useI18n } from '@/ui/i18n/I18nProvider';
import styles from './ScreenSkeleton.module.css';

/**
 * Shown for the instant a menu screen's code is still on its way (M4-02 skeleton): the shape of a page,
 * softly shimmering (still with reduced motion), instead of nothing at all.
 */
export function ScreenSkeleton() {
  const { t } = useI18n();
  return (
    <div className={styles.scrim} data-testid="screen-skeleton">
      <div className={styles.page} role="status" aria-label={t('ui.loading.opening')}>
        <span className={styles.title} />
        <span className={styles.line} />
        <span className={styles.line} />
        <span className={styles.block} />
        <span className={styles.block} />
      </div>
    </div>
  );
}
